// removed by extract-text-webpack-plugin
module.exports = {"sidebarContainer":"Sidebar__sidebarContainer___2w1kR","hamburgerButton":"Sidebar__hamburgerButton___1m3Dv","sidebar":"Sidebar__sidebar___1UaBg","closeSidebarIcon":"Sidebar__closeSidebarIcon___3_vfz","sidebarMenu":"Sidebar__sidebarMenu___kysfE","sidebarMenuItem":"Sidebar__sidebarMenuItem___1n3ZY","sidebarMenuItemButton":"Sidebar__sidebarMenuItemButton___1ZTGz","displaySidebar":"Sidebar__displaySidebar___1qxB8"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/common/header/sidebar/Sidebar.scss
// module id = 1147
// module chunks = 0